export default [
	{
		id: 0,
		useInEbiz: false,
		originalText: 'Működik',
		displayTexts: {
			hu: 'Működik',
			en: 'TODO English text'
		}
	},
	{
		id: 1,
		useInEbiz: true,
		originalText: 'A cég megszűnt',
		displayTexts: {
			hu: 'Megszűnt',
			en: 'TODO English text'
		}
	},
	{
		id: 2,
		useInEbiz: false,
		originalText: 'Nem használt',
		displayTexts: {
			hu: 'TODO Magyar szöveg',
			en: 'TODO English text'
		}
	},
	{
		id: 3,
		useInEbiz: true,
		originalText: 'A cég végelszámolási eljárás alatt áll',
		displayTexts: {
			hu: 'Végelszámolási eljárás',
			en: 'TODO English text'
		}
	},
	{
		id: 4,
		useInEbiz: true,
		originalText: 'A cég felszámolási eljárás alatt áll',
		displayTexts: {
			hu: 'Felszámolási eljárás',
			en: 'TODO English text'
		}
	},
	{
		id: 5,
		useInEbiz: true,
		originalText: 'A cég csőd eljárás alatt áll',
		displayTexts: {
			hu: 'Csőd eljárás',
			en: 'TODO English text'
		}
	},
	{
		id: 6,
		useInEbiz: true,
		originalText: 'A cég átalakulás útján megszűnt',
		displayTexts: {
			hu: 'Átalakulás útján megszűnt',
			en: 'TODO English text'
		}
	},
	{
		id: 7,
		useInEbiz: true,
		originalText: 'A cég Bírósági törlési eljárás alatt',
		displayTexts: {
			hu: 'Átalakulás útján megszűnt',
			en: 'TODO English text'
		}
	},
	{
		id: 8,
		useInEbiz: false,
		originalText: 'A cég bejegyzési kérelme elutasítva',
		displayTexts: {
			hu: 'TODO Magyar szöveg',
			en: 'TODO English text'
		}
	},
	{
		id: 9,
		useInEbiz: false,
		originalText: 'A cég törlési eljárása megindítva',
		displayTexts: {
			hu: 'TODO Magyar szöveg',
			en: 'TODO English text'
		}
	},
	{
		id: 10,
		useInEbiz: false,
		originalText: 'A cég állapota bizonytalan',
		displayTexts: {
			hu: 'TODO Magyar szöveg',
			en: 'TODO English text'
		}
	},
	{
		id: 11,
		useInEbiz: false,
		originalText: 'Végelszámolás befejezve',
		displayTexts: {
			hu: 'TODO Magyar szöveg',
			en: 'TODO English text'
		}
	},
	{
		id: 12,
		useInEbiz: false,
		originalText: 'Felszámolás befejezve',
		displayTexts: {
			hu: 'TODO Magyar szöveg',
			en: 'TODO English text'
		}
	},
	{
		id: 13,
		useInEbiz: true,
		originalText: 'A cég kényszertörlési eljárás alatt áll',
		displayTexts: {
			hu: 'Kényszertörlési eljárás',
			en: 'TODO English text'
		}
	},
	{
		id: 14,
		useInEbiz: false,
		originalText: 'Szüneteltetett vállalkozói tevékenység',
		displayTexts: {
			hu: 'TODO Magyar szöveg',
			en: 'TODO English text'
		}
	},
	{
		id: 15,
		useInEbiz: false,
		originalText: 'Egyéni céggé alakult',
		displayTexts: {
			hu: 'TODO Magyar szöveg',
			en: 'TODO English text'
		}
	},
	{
		id: 16,
		useInEbiz: false,
		originalText: 'Eljárással érintett',
		displayTexts: {
			hu: 'TODO Magyar szöveg',
			en: 'TODO English text'
		}
	}
];
